// extracted by mini-css-extract-plugin
module.exports = {"container":"FileUploader_container__NjP2O","icon":"FileUploader_icon__1OXNa"};